import dayjs from 'dayjs';
import { useMutation } from '@apollo/client';
import {useQuery} from "@apollo/react-hooks";
import { ISelectItem } from '../../../../../libs/uiKit/select/types';
import { PrecalculationForm } from '../../ui/context';
import {DEFAULT_INSURANCE_TYPE, DEFAULT_RISKS, RADIO_SEX} from '../../../../../libs/utils/staticData';
import {
    AddressFragment,
    LoadAgreementQuery,
    MeQuery, MeQueryVariables,
    PrecalcMutation,
    PrecalcMutationVariables,
    SaveAgreementMutation,
    SaveAgreementMutationVariables
} from '../../../../../libs/api/graphqlTypes';
import { SAVE_AGREEMENT_DRAFT } from '../../../../../libs/api/commands';
import useNotification from '../../../../widgets/notifier/ui/hooks/useNitification';
import { ITabItem } from '../../../../../libs/uiKit/tabs/types';
import {ME, PRECALCULATION} from '../../../../../libs/api/queries';
import {isMoRegion, isNewRegion} from "../../../../../libs/utils/address";
import {CreateAgreementForm} from "../../../createAgreement/ui/context";
import {IDaDataValue} from "../../../../../libs/uiKit/daData/types";
import {getClearSelectValue} from "../../../../../libs/utils/getSelectdefaultValue";

type createAgreementCmdProps = {
	bank?: ISelectItem;
	formData: PrecalculationForm;
	tabValue?: ITabItem;
	callback: (isn: string) => void;
	expressMode?: boolean;
	crossId: number | null | undefined;
    promocode?: string;
    discount?: number;
    discountSk?: number;
    resultItem: any;
    id?: number;
};

type precalculationCmdProps = {
	tabValue?: ITabItem;
	formData: PrecalculationForm;
	callback: () => void;
};

const usePrecalculationCommands = (): {
	createAgreementCmd: (cmd: createAgreementCmdProps) => void;
	isLoadingSaveAgreement: boolean;
} => {
	const { setNotification } = useNotification();
	const { data: dataUser } = useQuery<MeQuery, MeQueryVariables>(ME);

	const [saveAgreement, { loading: loadingSaveAgreement }] = useMutation<SaveAgreementMutation, SaveAgreementMutationVariables>(SAVE_AGREEMENT_DRAFT);

	const createAgreementCmd = ({ bank, formData, tabValue, callback, expressMode, crossId, promocode, discount, discountSk, resultItem, id }: createAgreementCmdProps): void => {
		const { life, property, title, borrowers = [], summ, creditIssueDate, dealCountry, insuranceType, properties, agentIsn } = formData;
		const contragent = borrowers[0];
        const coBorrowers = borrowers.length > 1 ? borrowers.slice(1) : [];

		const rate:number|null = formData?.banks?.[0]?.rate || 0;

        const borrower = {
            birthday: contragent?.birthDate ? dayjs(contragent?.birthDate).format('DD.MM.YYYY') : null,
            sex: contragent?.sex,
            employment: {
                riskGroup: contragent?.riskGroup,
                profession: contragent?.profession,
            },
            share: Number(contragent?.share) || 100,
        };

		saveAgreement({
			variables: {
                id,
				calcForm: {
                    riskLife: life,
                    riskProperty: property,
                    riskTitle: title && !resultItem?.warning,
					isHouseFinished: tabValue?.value === '1',
					insuranceType: parseInt(insuranceType?.value || '1', 10),
					policyholder: expressMode ? null : borrower,
                    borrower: expressMode ? borrower : null,
					credit: {
						city: dealCountry,
						insuranceType: parseInt(insuranceType?.value || '1', 10),
						creditSum: summ,
						creditIssueDate: creditIssueDate ? dayjs(creditIssueDate).format('DD.MM.YYYY') : null,
						borrowerShare: Number(contragent?.share) || 0,
						bank: bank || null,
						creditRate: rate,
						birthDateMethod: contragent?.birthDateMethod || { value: '0', label: 'По году рождения' },
						agent: agentIsn,
					},
                    coBorrowers: coBorrowers.map(coBorrower => (
                        {
                            birthday: coBorrower?.birthDate ? dayjs(coBorrower?.birthDate).format('DD.MM.YYYY') : null,
                            share: Number(coBorrower?.share) || 0,
                            sex: coBorrower?.sex,
                            employment: {
                                riskGroup: coBorrower?.riskGroup,
                                profession: coBorrower?.profession,
                            }
                        }
                    )),
					propertyObjects:  properties?.map(property => ({
						propertyPledge: property?.objectType,
						buildYear: Number(property?.objectBuildYear) || null,
						woodInConstruction: property?.woodInConstruction,
						floorMaterial: property?.floorMaterial,
						wallMaterial: property?.wallMaterial,
						pledgeShare: Number(property?.pledgeShare) || null,
						//objectCost: Number(property?.subjectCost) || null,
					})),
					expressMode: expressMode || false,
					promocode,
					crossId,
                    discountKv: discount,
					discountSk,
                    precalcResult: { ...resultItem, promocode, discount, discountSk, }
				},
                fromPrecalc: true,
			},
		})
			.then(({ data }) => {
				if (!data?.saveAgreement) return setNotification({ type: 'error', text: 'empty agreement id' });
				callback(data.saveAgreement);
			})
			.catch(error => setNotification({ type: 'error', text: error }));
	};


	return {
		createAgreementCmd,
		isLoadingSaveAgreement: loadingSaveAgreement,
	};
};

export default usePrecalculationCommands;
